import { useEffect, useRef } from 'react'

interface UseAnimationStateProps {
	ref: React.RefObject<HTMLElement>
	onAnimationEnd?: () => void
	onAnimationStart?: () => void
}

export const useAnimationState = ({
	ref,
	onAnimationEnd,
	onAnimationStart,
}: UseAnimationStateProps): {
	isAnimatingRef: React.MutableRefObject<boolean>
} => {
	const isAnimatingRef = useRef(false)

	useEffect(() => {
		const element = ref.current
		if (!element) return

		const handleAnimationStart = (): void => {
			isAnimatingRef.current = true
			onAnimationStart?.()
		}

		const handleAnimationEnd = (): void => {
			isAnimatingRef.current = false
			onAnimationEnd?.()
		}

		element.addEventListener('animationstart', handleAnimationStart)
		element.addEventListener('animationend', handleAnimationEnd)

		return () => {
			element.removeEventListener('animationstart', handleAnimationStart)
			element.removeEventListener('animationend', handleAnimationEnd)
		}
	}, [ref, onAnimationEnd, onAnimationStart])

	return { isAnimatingRef }
}
